import { CreateSubscriptionWithPlanBody as SubscriptionInput } from '@cel_cash/core/schemas'
import type {
    InvoiceConfig,
    PaymentMethodBoleto,
    PaymentMethodCreditCard,
    Plan,
    Subscription,
    Transaction,
} from '@cel_cash/core/types'
import ApiService from '../api.service'

interface TransactionInput {
    myId: string
    value: number
    payday: Date
    payedOutsideGalaxPay: boolean
    additionalInfo: string
    PaymentMethodCreditCard: PaymentMethodCreditCard
    InvoiceConfig: InvoiceConfig
}

type Input = Omit<
    SubscriptionInput,
    'myId' | 'firstPayDayDate' | 'planGalaxPayId'
>

type Assinatura = {
    mainPaymentMethodId: Plan['PlanPrices'][number]['payment']
    limiteFuncionarios: number
    periodicity: Plan['periodicity']
    PaymentMethodCreditCard?: PaymentMethodCreditCard
    PaymentMethodBoleto?: PaymentMethodBoleto
}

const assinaturasService = new ApiService<Input, Subscription>('assinaturas')
const alteracao = new ApiService<Assinatura & { agora: boolean }, Subscription>(
    'assinaturas/change',
)

export const assinaturas = Object.assign(assinaturasService, {
    minhaAssinatura: new ApiService<Subscription>(
        'parametros-financeiros/minha-assinatura',
    ),
    alteracao,
})

type CreateCardBody = {
    number: string
    customerMyId: string
    holder: string
    expiresAt: string
    cvv: string
}

interface DBCard {
    id: number
    clienteId: number
    myId: string
    nome: string
    isBackup: boolean
    createdAt: Date
}

export const cartoes = new ApiService<
    CreateCardBody,
    DBCard,
    { clienteId?: number }
>('cartoes')

const transacoesService = new ApiService<TransactionInput, Transaction>(
    'transacoes',
)

export const transacoes = Object.assign(transacoesService, {
    retry: (galaxPayId: string) =>
        transacoesService.put(`${galaxPayId}/retry`, {}),
})
